import React, { useMemo } from "react";
import {
  MimaButton,
  MimaDropdown,
  MimaDropZone,
  MimaInput,
  MimaMultiDropdown,
  MimaPaginatedDropdown,
  MimaTagInput,
  MimaText,
  Modal,
  ReceiptCheckBox as RCB,
  ReactQuillInput,
} from "../../components";
import { Field, FieldArray, Formik } from "formik";
import { fashCreativeStore } from "../../stores";
import { colorsArray } from "../../utils/utils";

const FieldInput = ({ field, ...props }) => {
  return <MimaInput {...field} {...props} />;
};

const AddCatalogueModal = ({
  closeModal,
  onSubmit,
  validationSchema,
  loading,
  hashTags,
  setHashTags,
  setFilterQuery,
  newCollections,
  setNewCollections,
}) => {
  const foreignCurrencyData = [{ key: "USD", value: "USD" }];
  const localCurrencyData = [{ key: "NGN", value: "NGN" }];
  const sizeArray = [
    "XXS",
    "XS",
    "S",
    "M",
    "L",
    "XL",
    "2XL",
    "3XL",
    "4XL",
    "5XL",
  ].map((x) => {
    return { key: x, value: x };
  });

  const newColorsArray = colorsArray.map((x) => {
    return { key: x.code, value: x.color };
  });

  const collections = fashCreativeStore?.collections;

  const collectionsData = useMemo(() => {
    return collections.map((x) => ({
      key: x.key,
      value: x.name,
    }));
  }, [collections]);

  const collectionSuggestion = useMemo(() => {
    return collections.map((x) => ({
      a: x.name,
    }));
  }, [collections]);

  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" mb={4} width={38} align="center">
        Add Product to Catalogue
      </MimaText>

      <Formik
        initialValues={{
          name: "",
          designerName: "",
          description: "",
          gender: "MALE",
          videoUrls: [{ url: "" }],
          addLocalSellingPrice: false,
          local: {
            withoutMaterial: 0,
            currencyCode: "NGN",
            onSaleSlashPrice: 0,
            withMaterial: 0,
          },
          sellAbroad: false,
          international: {
            currencyCode: "USD",
            withMaterial: 0,
            onSaleSlashPrice: 0,
          },
          addDeliveryDuration: false,
          daysRequiredForDelivery: {
            early: 0,
            late: 0,
          },
          styleCollections: [],
          createCollections: false,
          isMigration: false,
          files: [],
          topView: false,
          isSoldOut: false,
          bestSelling: false,
          colorsAvailable: [
            {
              color: "",
              code: "",
            },
          ],
          addCustomColor: false,
          customColors: [],
          sizes: [],
          accessories: [],
        }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        {({
          handleBlur,
          handleChange,
          setFieldValue,
          values,
          errors,
          touched,
          handleSubmit,
        }) => (
          <>
            <MimaInput
              labelTitle="Style Name"
              placeholder="Enter Style Name"
              id="name"
              name="name"
              value={values.name}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.name}
              touched={touched.name}
              mb={2}
            />

            <div style={{ marginBottom: "2rem" }}>
              <MimaText variant="small" mb={1}>
                Are you Migrating for a Fash User?
              </MimaText>
              <div className="modal__beside">
                <RCB
                  title="Yes"
                  onChange={() => {
                    setFieldValue("isMigration", true);
                  }}
                  checked={values.isMigration}
                  value={values.isMigration}
                  name="isMigration"
                />
                <RCB
                  title="No"
                  onChange={() => {
                    setFieldValue("isMigration", false);
                  }}
                  checked={!values.isMigration}
                  value={!values.isMigration}
                  name="isMigration"
                />
              </div>
              {errors.isMigration ? (
                <MimaText variant="small" color="var(--color-error)">
                  {""}
                  {touched.isMigration && errors.isMigration}
                  {""}
                </MimaText>
              ) : null}
            </div>

            {values.isMigration ? (
              <MimaPaginatedDropdown
                type="text"
                name="Designer"
                id="Designer"
                value={values.tradingName}
                queryKey={["getAllSignedBusinesses"]}
                optionLabel="tradingName"
                labelTitle="Select business"
                placeholder="Select business"
                touched={touched?.business}
                error={errors?.business}
                url="/businesses"
                getPageValue={(page) => page?.data?.businesses || []}
                getPageTotalCount={(lastPage) => lastPage?.data?.count || 0}
                onChange={(data) => {
                  setFieldValue("business", data._id);
                  setFieldValue("designerName", data.tradingName);
                  setFilterQuery(data._id);
                }}
                width={38}
              />
            ) : (
              <MimaInput
                labelTitle="Designer"
                placeholder="Enter Name of Designer"
                id="designerName"
                name="designerName"
                value={values.designerName}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors.designerName}
                touched={touched.designerName}
              />
            )}
            <div style={{ width: "38rem" }}>
              <MimaDropZone
                title="Upload Product Images"
                info="maximum image Size 1MB"
                maxNumOfImages={10}
                files={values.files}
                setFiles={(newFiles) => {
                  setFieldValue("files", newFiles);
                }}
                labelTitle="Upload Images"
                name="imageUrls"
              />
            </div>

            {values.isMigration ? (
              <>
                <div style={{ marginBottom: "2rem" }}>
                  <MimaText variant="small" mb={1} mt={1}>
                    Set as best selling
                  </MimaText>
                  <div className="modal__beside">
                    <RCB
                      title="Yes"
                      onChange={() => {
                        setFieldValue("bestSelling", true);
                      }}
                      checked={values.bestSelling}
                      value={values.bestSelling}
                      name="bestSelling"
                    />
                    <RCB
                      title="No"
                      onChange={() => {
                        setFieldValue("bestSelling", false);
                      }}
                      checked={!values.bestSelling}
                      value={!values.bestSelling}
                      name="bestSelling"
                    />
                  </div>
                </div>
                <div style={{ marginBottom: "2rem" }}>
                  <MimaText variant="small" mb={1} mt={1}>
                    Set as out of stock
                  </MimaText>
                  <div className="modal__beside">
                    <RCB
                      title="Yes"
                      onChange={() => {
                        setFieldValue("isSoldOut", true);
                      }}
                      checked={values.isSoldOut}
                      value={values.isSoldOut}
                      name="isSoldOut"
                    />
                    <RCB
                      title="No"
                      onChange={() => {
                        setFieldValue("isSoldOut", false);
                      }}
                      checked={!values.isSoldOut}
                      value={!values.isSoldOut}
                      name="isSoldOut"
                    />
                  </div>
                </div>
                <div style={{ marginBottom: "2rem" }}>
                  <MimaText variant="small" mb={1} mt={1}>
                    Pin Style To Top
                  </MimaText>
                  <div className="modal__beside">
                    <RCB
                      title="Yes"
                      onChange={() => {
                        setFieldValue("topView", true);
                      }}
                      checked={values.topView}
                      value={values.topView}
                      name="topView"
                    />
                    <RCB
                      title="No"
                      onChange={() => {
                        setFieldValue("topView", false);
                      }}
                      checked={!values.topView}
                      value={!values.topView}
                      name="topView"
                    />
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            <div className="modal__h__line"></div>
            <FieldArray name="videoUrls">
              {({ push, remove }) => (
                <React.Fragment>
                  {values.videoUrls.map((_, i) => (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        gap: "2rem",
                        alignItems: "center",
                        width: "38rem",
                      }}
                    >
                      <Field
                        name={`videoUrls.${i}.url`}
                        component={FieldInput}
                        labelTitle={`Video Link ${i + 1}`}
                        width={i !== 0 ? 26 : 38}
                        // disabled={values.selectFromStock}
                        // touched={touched?.orders?.[i]?.unitPrice}
                        // error={errors?.orders?.[i]?.unitPrice}
                      />

                      {i !== 0 ? (
                        <MimaButton
                          title="Remove"
                          variant="filter"
                          type="button"
                          buttonColor="var(--color-error)"
                          width={10}
                          onClick={() => remove(i)}
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  ))}
                  <MimaButton
                    title="Add Another Video link"
                    variant="colorable"
                    type="button"
                    onClick={() =>
                      push({
                        url: "",
                      })
                    }
                    width={38}
                    buttonColor="var(--color-dark)"
                  />
                </React.Fragment>
              )}
            </FieldArray>
            <div className="modal__h__line"></div>

            {values.isMigration ? (
              <>
                <div style={{ marginBottom: "2rem" }}>
                  <MimaText variant="small" mb={1}>
                    Do You Want To Create New Collection ?
                  </MimaText>
                  <div className="modal__beside">
                    <RCB
                      title="Yes"
                      onChange={() => {
                        setFieldValue("createCollections", true);
                      }}
                      checked={values.createCollections}
                      value={values.createCollections}
                      name="createCollections"
                    />
                    <RCB
                      title="No"
                      onChange={() => {
                        setFieldValue("createCollections", false);
                      }}
                      checked={!values.createCollections}
                      value={!values.createCollections}
                      name="createCollections"
                    />
                  </div>
                  {errors.createCollections ? (
                    <MimaText variant="small" color="var(--color-error)">
                      {""}
                      {touched.createCollections && errors.createCollections}
                      {""}
                    </MimaText>
                  ) : null}

                  {!values.createCollections ? (
                    <>
                      <MimaMultiDropdown
                        labelTitle="Style Collection"
                        name="styleCollections"
                        id="styleCollections"
                        value={values.styleCollections}
                        placeholder="Select Collection"
                        currentValue={values.styleCollections}
                        onChange={(data) => {
                          setFieldValue("styleCollections", data);
                        }}
                        data={collectionsData}
                        touched={touched.styleCollections}
                        error={errors.styleCollections}
                        mt={2}
                      />
                    </>
                  ) : (
                    <MimaTagInput
                      placeholder="Style Collection"
                      labelTitle="Enter New Collection"
                      tags={newCollections}
                      setTags={setNewCollections}
                      name="styleCollections"
                      onBlur={handleBlur}
                      error={errors.mobile}
                      touched={touched.mobile}
                      width={38}
                      mt={2}
                      suggestionData={collectionSuggestion}
                      handleFilter={(item, text) => {
                        return item?.a?.toLowerCase()?.includes(text);
                      }}
                    />
                  )}
                </div>
                <div style={{ marginBottom: "2rem" }}>
                  <MimaText variant="small" mb={1} mt={1}>
                    Do You Want To Add Local Selling Price ?
                  </MimaText>
                  <div className="modal__beside">
                    <RCB
                      title="Yes"
                      onChange={() => {
                        setFieldValue("addLocalSellingPrice", true);
                      }}
                      checked={values.addLocalSellingPrice}
                      value={values.addLocalSellingPrice}
                      name="addLocalSellingPrice"
                    />
                    <RCB
                      title="No"
                      onChange={() => {
                        setFieldValue("addLocalSellingPrice", false);
                      }}
                      checked={!values.addLocalSellingPrice}
                      value={!values.addLocalSellingPrice}
                      name="addLocalSellingPrice"
                    />
                  </div>
                  {values.addLocalSellingPrice && (
                    <>
                      <MimaDropdown
                        labelTitle="Select Currency"
                        name={`local.currencyCode`}
                        value={values.local.currencyCode}
                        placeholder={values.local.currencyCode}
                        id={`local.currencyCode`}
                        currentValue={values.local.currencyCode}
                        onChange={(data) => {
                          setFieldValue(`local.currencyCode`, data.key);
                        }}
                        data={localCurrencyData}
                        touched={touched.currencyCode}
                        error={errors.currencyCode}
                        width={18}
                        mt={2}
                      />

                      <div className="modal__beside">
                        <MimaInput
                          type="number"
                          labelTitle="Ready To wear Price(RTW)"
                          name={`local.withMaterial`}
                          id={`local.withMaterial`}
                          value={values.local.withMaterial}
                          onChange={handleChange}
                          error={errors?.local?.withMaterial}
                          touched={touched?.local?.withMaterial}
                          onBlur={handleBlur}
                          width={18}
                        />

                        <MimaInput
                          type="number"
                          labelTitle="Price With Customer's Material"
                          name={`local.withoutMaterial`}
                          id={`local.withoutMaterial`}
                          value={values.local.withoutMaterial}
                          onChange={handleChange}
                          error={errors?.local?.withoutMaterial}
                          touched={touched?.local?.withoutMaterial}
                          onBlur={handleBlur}
                          width={18}
                        />
                      </div>
                      <MimaInput
                        type="number"
                        labelTitle="Sales Slash Price"
                        name={`local.onSaleSlashPrice`}
                        id={`local.onSaleSlashPrice`}
                        value={values.local.onSaleSlashPrice}
                        onChange={handleChange}
                        error={errors?.local?.onSaleSlashPrice}
                        touched={touched?.local?.onSaleSlashPrice}
                        onBlur={handleBlur}
                      />
                    </>
                  )}
                </div>
                <div style={{ marginBottom: "2rem" }}>
                  <MimaText variant="small" mb={1} mt={1}>
                    Do you want to Sell This Style Abroad ?
                  </MimaText>
                  <div className="modal__beside">
                    <RCB
                      title="Yes"
                      onChange={() => {
                        setFieldValue("sellAbroad", true);
                      }}
                      checked={values.sellAbroad}
                      value={values.sellAbroad}
                      name="sellAbroad"
                    />
                    <RCB
                      title="No"
                      onChange={() => {
                        setFieldValue("sellAbroad", false);
                      }}
                      checked={!values.sellAbroad}
                      value={!values.sellAbroad}
                      name="sellAbroad"
                    />
                  </div>
                  {values.sellAbroad && (
                    <>
                      <MimaDropdown
                        labelTitle="Select Currency"
                        name={`international.currencyCode`}
                        value={values.international.currencyCode}
                        placeholder={values.international.currencyCode}
                        id={`international.currencyCode`}
                        currentValue={values.international.currencyCode}
                        onChange={(data) => {
                          setFieldValue(`international.currencyCode`, data.key);
                        }}
                        data={foreignCurrencyData}
                        touched={touched?.international?.currencyCode}
                        error={errors?.international?.currencyCode}
                        width={18}
                        mt={2}
                      />

                      <div className="modal__beside">
                        <MimaInput
                          type="number"
                          labelTitle="International Price"
                          name={`international.withMaterial`}
                          id={`international.withMaterial`}
                          value={values.international.withMaterial}
                          onChange={handleChange}
                          error={errors?.international?.withMaterial}
                          touched={touched?.international?.withMaterial}
                          onBlur={handleBlur}
                          width={18}
                        />
                        <MimaInput
                          type="number"
                          labelTitle="Sales Slash Price"
                          name={`international.onSaleSlashPrice`}
                          id={`international.onSaleSlashPrice`}
                          value={values.international.onSaleSlashPrice}
                          onChange={handleChange}
                          error={errors?.international?.onSaleSlashPrice}
                          touched={touched?.international?.onSaleSlashPrice}
                          onBlur={handleBlur}
                          width={18}
                        />
                      </div>
                    </>
                  )}
                </div>
                <div style={{ marginBottom: "2rem" }}>
                  <MimaText variant="small" mb={1} mt={1} align="center">
                    Add Delivery Duration ?
                  </MimaText>
                  <div className="modal__beside">
                    <MimaInput
                      type="number"
                      labelTitle="Min Est. Duration"
                      name={`daysRequiredForDelivery.early`}
                      id={`daysRequiredForDelivery.early`}
                      value={values.daysRequiredForDelivery.early}
                      onChange={handleChange}
                      error={errors?.daysRequiredForDelivery?.early}
                      touched={touched?.daysRequiredForDelivery?.early}
                      width={18}
                      mt={2}
                    />

                    <MimaInput
                      type="number"
                      labelTitle="Max Est. Duration"
                      name={`daysRequiredForDelivery.late`}
                      id={`daysRequiredForDelivery.late`}
                      value={values.daysRequiredForDelivery.late}
                      onChange={handleChange}
                      error={errors?.daysRequiredForDelivery?.late}
                      touched={touched?.daysRequiredForDelivery?.late}
                      onBlur={handleBlur}
                      width={18}
                      mt={2}
                    />
                  </div>
                  {/* <div className="modal__beside">
                    <RCB
                      title="Yes"
                      onChange={() => {
                        setFieldValue("addDeliveryDuration", true);
                      }}
                      checked={values.addDeliveryDuration}
                      value={values.addDeliveryDuration}
                      name="addDeliveryDuration"
                    />
                    <RCB
                      title="No"
                      onChange={() => {
                        setFieldValue("addDeliveryDuration", false);
                      }}
                      checked={!values.addDeliveryDuration}
                      value={!values.addDeliveryDuration}
                      name="addDeliveryDuration"
                    />
                  </div> */}
                  {/* {values.addDeliveryDuration && (
                    <div className="modal__beside">
                      <MimaInput
                        type="number"
                        labelTitle="Min Est. Duration"
                        name={`daysRequiredForDelivery.early`}
                        id={`daysRequiredForDelivery.early`}
                        value={values.daysRequiredForDelivery.early}
                        onChange={handleChange}
                        error={errors?.daysRequiredForDelivery?.early}
                        touched={touched?.daysRequiredForDelivery?.early}
                        width={18}
                        mt={2}
                      />

                      <MimaInput
                        type="number"
                        labelTitle="Max Est. Duration"
                        name={`daysRequiredForDelivery.late`}
                        id={`daysRequiredForDelivery.late`}
                        value={values.daysRequiredForDelivery.late}
                        onChange={handleChange}
                        error={errors?.daysRequiredForDelivery?.late}
                        touched={touched?.daysRequiredForDelivery?.late}
                        onBlur={handleBlur}
                        width={18}
                        mt={2}
                      />
                    </div>
                  )} */}
                </div>
                <MimaMultiDropdown
                  labelTitle="Colors"
                  name="colorsAvailable"
                  id="colorsAvailable"
                  value={values.colorsAvailable}
                  placeholder="Select Colors"
                  currentValue={values.colorsAvailable}
                  onChange={(data) => {
                    setFieldValue("colorsAvailable", data);
                  }}
                  data={newColorsArray}
                  touched={touched.colorsAvailable}
                  error={errors.colorsAvailable}
                  mt={2}
                  mb={2}
                />

                <div style={{ marginBottom: "2rem" }}>
                  <MimaText variant="small" mb={1}>
                    Add Custom Colors or Color combinations
                  </MimaText>
                  <div className="modal__beside">
                    <RCB
                      title="Yes"
                      onChange={() => {
                        setFieldValue("addCustomColor", true);
                      }}
                      checked={values.addCustomColor}
                      value={values.addCustomColor}
                      name="addCustomColor"
                    />
                    <RCB
                      title="No"
                      onChange={() => {
                        setFieldValue("addCustomColor", false);
                      }}
                      checked={!values.addCustomColor}
                      value={!values.addCustomColor}
                      name="addCustomColor"
                    />
                  </div>
                  {errors.addCustomColor ? (
                    <MimaText variant="small" color="var(--color-error)">
                      {""}
                      {touched.addCustomColor && errors.addCustomColor}
                      {""}
                    </MimaText>
                  ) : null}
                </div>

                {values.addCustomColor ? (
                  <MimaTagInput
                    placeholder="Enter custom colors"
                    labelTitle="Custom Colors"
                    tags={values.customColors}
                    setTags={(custom) => {
                      setFieldValue("customColors", custom);
                    }}
                    name="customColors"
                    onBlur={handleBlur}
                    error={errors.mobile}
                    touched={touched.mobile}
                    width={38}
                    mt={2}
                    // suggestionData={collectionSuggestion}
                    // handleFilter={(item, text) => {
                    //   return item?.a?.toLowerCase()?.includes(text);
                    // }}
                  />
                ) : (
                  ""
                )}

                <MimaMultiDropdown
                  labelTitle="Sizes"
                  name="sizes"
                  id="sizes"
                  value={values.sizes}
                  placeholder="Select Sizes"
                  currentValue={values.sizes}
                  onChange={(data) => {
                    setFieldValue("sizes", data);
                  }}
                  data={sizeArray}
                  touched={touched.sizes}
                  error={errors.sizes}
                  mt={2}
                  mb={2}
                />

                <MimaTagInput
                  placeholder="Add Accessories Types"
                  labelTitle="Accessory Informations"
                  tags={values.accessories}
                  setTags={(item) => {
                    setFieldValue("accessories", item);
                  }}
                  name="accessories"
                  onBlur={handleBlur}
                  error={errors.mobile}
                  touched={touched.mobile}
                  width={38}
                  mt={2}

                  // suggestionData={collectionSuggestion}
                  // handleFilter={(item, text) => {
                  //   return item?.a?.toLowerCase()?.includes(text);
                  // }}
                />
              </>
            ) : (
              ""
            )}

            <ReactQuillInput
              name="description"
              labelTitle="Description"
              error={errors.description}
              touched={touched.description}
              placeholder="Enter description"
              width={38}
              mt={2}
              mb={2}
            />
            <div className="modal__beside">
              <RCB
                title="Male"
                onChange={() => {
                  setFieldValue("gender", "MALE");
                }}
                checked={values.gender === "MALE"}
                value="MALE"
                name="gender"
              />
              <RCB
                title="Female"
                onChange={() => setFieldValue("gender", "FEMALE")}
                checked={values.gender === "FEMALE"}
                value="FEMALE"
                name="gender"
              />
              <RCB
                title="Unisex"
                onChange={() => setFieldValue("gender", "UNISEX")}
                checked={values.gender === "UNISEX"}
                value="UNISEX"
                name="gender"
              />
            </div>

            <MimaTagInput
              placeholder="Enter Hashtags"
              labelTitle="Hashtags"
              tags={hashTags}
              setTags={setHashTags}
              name="hashTags"
              onBlur={handleBlur}
              error={errors.mobile}
              touched={touched.mobile}
              width={38}
              mt={2}
            />

            <MimaButton
              title="Confirm Action"
              type="submit"
              onClick={handleSubmit}
              width={38}
              buttonColor="var(--color-admin)"
              loading={loading}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default AddCatalogueModal;
